import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen overflow-hidden  ">
      {/* Left side - Auth forms */}
      <div className=" w-full   ">
        {/* Theme switcher */}
        {/* <div className="flex justify-end mb-8">
          <ThemeSwitcher />
        </div> */}

        {/* Logo and title */}
        <div className="absolute top-6 left-4 lg:left-14 z-20">
          <img src="/images/mstlogo.svg" alt="MST Logo" className="" />
        </div>

        {/* Auth form content */}
        <Outlet />

        {/* Footer */}
        {/* <div className="mt-8 text-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} MST Buddy Admin.</p>
        </div> */}
      </div>
    </div>
  );
}
